import { render } from "./ChangePass.vue?vue&type=template&id=40940dc5"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"

import "./ChangePass.vue?vue&type=style&index=0&id=40940dc5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__